// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iPvH","col":"styles_col__3X7Oa"};